import { VStack } from "@chakra-ui/react";
import React from "react";
import SimpleSidebar from "../components/AdminSidebar";
import PostList from "./PostList";
import UserList from "./UserList";

const Admin = () => {
  return (
    <div style={{ display: "flex", justifyContent: "left" }}>
      <SimpleSidebar />
      <VStack>
        <UserList />
        <PostList />
      </VStack>
    </div>
  );
};

export default Admin;
